import { useState } from "react";
import { colors, space, radius, fontSize } from "../../design/tokens";

export default function Button({ children, slim, style, ...props }) {

  const [hovered, setHovered] = useState(false);

  return (
    <button
      style={{
        width: "100%",

        background: hovered ? colors.secondary : colors.primary,

        border: "none",
        outline: "none",

        borderRadius: slim ? radius.lg : radius.xl,

        padding: slim ? space.sm : space.lg,

        fontSize: slim ? fontSize.sm : fontSize.md,


        color: colors.text,

        cursor: "pointer",


        ...style,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
    >
      {children}
    </button>
  );
}